/*
 * @Description:
 * @Date: 2020-11-28 11:28:35
 * @LastEditors: jml
 * @LastEditTime: 2021-03-02 17:35:10
 */

import { percentage } from '@/tools/index';

const d = {
  1: 50,
  2: 28,
  3: 19,
  4: 14,
  5: 11,
  6: 8,
  7: 7,
  8: 6,
  9: 5,
  10: 5,
  11: 4,
  12: 4,
  13: 4,
  14: 3,
  15: 3
};
export const axisFormatter = (params, count) => {
  var newParamsName = ''; // 最终拼接成的字符串
  var paramsNameNumber = params.length; // 实际标签的个数
  var provideNumber = d[count] || 3; // 每行能显示的字的个数
  var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
  /**
   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
   */
  // 条件等同于rowNumber>1
  if (paramsNameNumber > provideNumber) {
    /** 循环每一行,p表示行 */
    for (var p = 0; p < rowNumber; p++) {
      var tempStr = ''; // 表示每一次截取的字符串
      var start = p * provideNumber; // 开始截取的位置
      var end = start + provideNumber; // 结束截取的位置
      // 此处特殊处理最后一行的索引值
      if (p == rowNumber - 1) {
        // 最后一次不换行
        tempStr = params.substring(start, paramsNameNumber);
      } else {
        // 每一次拼接字符串并换行
        tempStr = `${params.substring(start, end)}\n`;
      }
      newParamsName += tempStr; // 最终拼成的字符串
    }
  } else {
    // 将旧标签的值赋给新标签
    newParamsName = params;
  }
  //将最终的字符串返回
  return newParamsName;
};

export const dealProvince = (arr, total) => {
  const pObj = arr.reduce((pre, cur) => {
    const { provinceName, cc } = cur;
    if (pre[provinceName]) {
      pre[provinceName] += cc;
    } else {
      pre[provinceName] = cc;
    }
    return pre;
  }, {});
  const series0data = Object.entries(pObj).reduce((pre, cur) => {
    pre.push({
      name: cur[0],
      value: cur[1]
    });
    return pre;
  }, []);

  let data = [];
  const maxLength = 5;
  if (series0data.length > maxLength) {
    const sData = series0data.sort((a, b) => a.value - b.value).reverse();
    const otherSum = sData.slice(maxLength).reduce((pre, cur) => {
      pre += cur.value;
      return pre;
    }, 0);
    data = sData
      .slice(0, maxLength)
      .map(i => {
        const { name, value } = i;
        return {
          d: name,
          v: value,
          b: percentage(value, total)
        };
      })
      .concat({
        d: '其他',
        v: otherSum,
        b: percentage(otherSum, total)
      });
  } else {
    data = series0data.reduce((pre, cur) => {
      const { name } = cur;
      pre.push({
        d: name,
        v: pObj[name],
        b: percentage(pObj[name], total)
      });
      return pre;
    }, []);
  }
  return { series0data, data };
};

export const dealTips = (str, value, unit, length = 20) => {
  const getStr = s => {
    return `<span style="font-size:12px;">${s}</span>`;
  };
  let _length = length;
  const _str = `${str}`;
  const arr = [_str.slice(0, length)];
  while (_length < _str.length) {
    arr.push(_str.slice(_length, _length + length));
    _length += length;
  }
  return getStr(arr.join('</br>') + `：${value}${unit}`);
};
